import {Link} from "react-router";
import {styled} from "styled-components";

const ListLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  pointer: cursor;
`;

export default ListLink;
